module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDCAMAAABdlVDoAAAAOVBMVEX////4tb3rM0v////3sLnoES33sbrrMSnxdyHygyD53Rb2uBr1sRvsOVDrLETxiCDsSib4yhn3yRiMlNkrAAAAA3RSTlPU4Pid7tDwAAAApUlEQVR4Ae3ZhRHFIBBF0bij/ff63XVhBn+3gROXpSJXNy/VFbmWWte/NLTUIkGAABmnW6MzpJ+XS3PvDrkqs9tzsh6NtXeLbEdkKwEBAgQIEEaNvyKcUat6cq8IvcDIbIrMFsgymyHzYoMsQr6njoiW74nFDjENSHSIn6vL+33i/47P5wHp532CdzwQIECA+J+t+J8S+Z93+Z/cYZoKJHrEy0rQHheHdLmsYT4eAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/gg.png
// module id = RS+b
// module chunks = 0